// База знаний: /api/v2/knowledge (erp-backend, модуль src/knowledge). Что видно — решает сервер по правам.
import { useAxiosCreate } from '@/backend/utils.js'

const api = useAxiosCreate('api')

export async function fetchKnowledge(q = '') {
  const { data } = await api.get('knowledge', { params: q ? { q } : {} })
  return data
}

export async function fetchArticle(slug) {
  const { data } = await api.get('knowledge/articles/' + encodeURIComponent(slug))
  return data
}
